<template>
    <input :value="model[field]" type="text" ref="input" @input="input($event.target.value)" :name="model[field]" />
</template>
<script>
    import moment from 'moment/moment'
    export default {
        data(){
            return {
            }
        },
        props: ['field','model'],
        methods: {
            setCaretPosition(ctrl, pos) {
                // Modern browsers
                if (ctrl.setSelectionRange) {
                    ctrl.focus();
                    ctrl.setSelectionRange(pos, pos);

                // IE8 and below
                } 
                else if (ctrl.createTextRange) {
                    var range = ctrl.createTextRange();
                    range.collapse(true);
                    range.moveEnd('character', pos);
                    range.moveStart('character', pos);
                    range.select();
                }
            },
            async input(value){
                const selectionStart = this.$refs.input.selectionStart
                Object.getPrototypeOf(this.model).$update({
                    where: this.model.id,
                    data: {
                        [this.field]: value ? value.toUpperCase() : value
                    }
                })
                this.$emit("input",value)
                await this.$nextTick()
                this.setCaretPosition(this.$refs.input,selectionStart)
            }
        },
        mounted(){
        }
    }
</script>

<style scoped>

</style>
